var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Usage',{attrs:{"line-chart-data":_vm.dailyData,"x-axis":_vm.xAxis,"grid":_vm.grid}},[_c('div',{staticClass:"title-wrap"},[_c('div',{staticClass:"today-usage-title"},[_c('span',[_vm._v("Today")]),_c('span',{staticClass:"seconds"},[_vm._v("100S")])]),_c('div',[_vm._v("Daily Average 35S")])]),_c('div',[_vm._v("Dec,15,2023-Today")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }